<!--
  Side view of the Provisionszeile (cp.ProvisionContract). Compact: the wide table only on
  explicit request, otherwise Basisdaten + Berechnung stacked.
-->
@if (initialized && dto) {

    <div class="cp-provision-contract-side mt-3">

        @if (activeNavigationItem?.action == 'contractAgents') {
            <cp-provision-contract-contract-agents
                    [provisionContractId]="objectIdentifier.objectId">
            </cp-provision-contract-contract-agents>
        } @else if (activeNavigationItem?.action == 'cancellation') {
            <cp-provision-contract-cancellation
                    [provisionContractId]="objectIdentifier.objectId"
                    [columns]="1">
            </cp-provision-contract-cancellation>
        } @else {
            <cp-provision-contract-base-data
                    [provisionContractId]="objectIdentifier.objectId"
                    [columns]="1">
            </cp-provision-contract-base-data>

            <div class="mt-3">
                <cp-provision-contract-calculation
                        [provisionContractId]="objectIdentifier.objectId"
                        [columns]="1">
                </cp-provision-contract-calculation>
            </div>
        }

    </div>

}
